/**
 * Demo catalog for Rehman Travel / A.R Travels
 * Contains exactly 2 Umrah packages, plus international destination tours across
 * multiple countries (Turkey, UAE, Malaysia, Azerbaijan, Thailand, UK),
 * and domestic Pakistan packages with all prices strictly configured in Pakistani Rupees (PKR).
 */

export const DEMO_PACKAGES = [
  // ============================================================
  // UMRAH PACKAGES (Exactly 2 packages kept as per requirements)
  // ============================================================
  {
    id: 'demo-umrah-comfort',
    name: 'Umrah Comfort 12 Days',
    title: 'Umrah Comfort 12 Days',
    packageName: 'Umrah Comfort 12 Days',
    slug: 'umrah-comfort-12-days',
    description: '4★ hotels near Haram, private transport, guided ziyarat & full board option.',
    image:
      'https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?auto=format&fit=crop&w=900&q=70',
    price: 2499,
    basePrice: 2499,
    currency: 'USD',
    duration: 12,
    nights: 11,
    nightsInMakkah: 7,
    nightsInMadina: 4,
    rating: 4.8,
    category: 'Umrah',
    packageCategory: 'Religious',
    packageSubType: 'Umrah',
    tripScope: 'International',
    destinationLabel: 'Makkah & Madina, Saudi Arabia',
    mealPlan: 'HB',
    includesGuide: true,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'Popular', color: '#1F6F78' }],
    includes: [
      'Hotel accommodation near Haram',
      'Airport transfers',
      'Ziyarat tours in Makkah & Madina',
      'Visa assistance guidance',
      '24/7 dedicated ground support',
    ],
    highlights: [
      '7 nights Makkah in 4★ hotel',
      '4 nights Madina in 4★ hotel',
      'Private group transport',
      'Guided ziyarat in both holy cities',
    ],
    itinerary: [
      { day: 1, title: 'Arrival Jeddah / Makkah', description: 'Airport pickup and transfer to Makkah hotel.' },
      { day: 2, title: 'Umrah Performance', description: 'Perform Umrah rituals with certified guide.' },
      { day: 5, title: 'Makkah Ziyarat', description: 'Visit Jabal al-Noor, Mina, Muzdalifah, and Arafat.' },
      { day: 8, title: 'Transfer to Madina', description: 'High-speed train or private coach transfer.' },
      { day: 12, title: 'Departure', description: 'Airport drop-off for flight back home.' },
    ],
    hotels: [
      { city: 'Makkah', name: 'Swissôtel Al Maqam (or similar)', stars: 4 },
      { city: 'Madina', name: 'Anwar Al Madinah Mövenpick', stars: 4 },
    ],
    transport: 'Private AC coach · Airport ↔ Hotel ↔ Ziyarat',
  },
  {
    id: 'demo-umrah-budget',
    name: 'Umrah Economy 10 Days',
    title: 'Umrah Economy 10 Days',
    packageName: 'Umrah Economy 10 Days',
    slug: 'umrah-economy-10-days',
    description: 'Affordable group Umrah with shared transport and 3★ comfortable stays.',
    image:
      'https://images.unsplash.com/photo-1564769625905-50e93615e769?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1564769625905-50e93615e769?auto=format&fit=crop&w=900&q=70',
    price: 1299,
    basePrice: 1299,
    currency: 'USD',
    duration: 10,
    nights: 9,
    nightsInMakkah: 5,
    nightsInMadina: 4,
    rating: 4.5,
    category: 'Umrah',
    packageCategory: 'Religious',
    packageSubType: 'Umrah',
    tripScope: 'International',
    destinationLabel: 'Makkah & Madina, Saudi Arabia',
    mealPlan: 'BB',
    includesGuide: true,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'Best Value', color: '#2E7D4F' }],
    includes: [
      '3★ Hotel accommodation',
      'Shared group bus transfers',
      'Ziyarat guidance',
      'Visa assistance',
    ],
    highlights: [
      '5 nights Makkah',
      '4 nights Madina',
      'Shared AC transport',
      'Free shuttle to Haram',
    ],
    itinerary: [
      { day: 1, title: 'Arrival', description: 'Airport pickup and hotel check-in.' },
      { day: 2, title: 'Umrah Performance', description: 'Guided group Umrah.' },
      { day: 6, title: 'Transfer to Madina', description: 'Group transfer to Madina hotel.' },
      { day: 10, title: 'Departure', description: 'Transfer to Madina/Jeddah airport.' },
    ],
    hotels: [
      { city: 'Makkah', name: 'Al Kiswah Towers', stars: 3 },
      { city: 'Madina', name: 'Emaar Elite Hotel', stars: 3 },
    ],
    transport: 'AC group coach · Airport ↔ Hotel',
  },

  // ============================================================
  // INTERNATIONAL PACKAGES - DIFFERENT COUNTRIES
  // ============================================================
  // 1. TURKEY
  {
    id: 'demo-turkey-ziyarat',
    name: 'Turkey Cultural & Ziyarat 8 Days',
    title: 'Turkey Cultural & Ziyarat 8 Days',
    packageName: 'Turkey Cultural & Ziyarat 8 Days',
    slug: 'turkey-ziyarat-8-days',
    description: 'Istanbul · Konya · Bursa — Islamic heritage, Sufi history, hotels, meals & guide.',
    image:
      'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?auto=format&fit=crop&w=900&q=70',
    price: 1899,
    basePrice: 1899,
    currency: 'USD',
    duration: 8,
    nights: 7,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.9,
    category: 'International',
    packageCategory: 'International',
    packageSubType: 'Cultural',
    tripScope: 'International',
    destinationLabel: 'Istanbul · Konya · Bursa, Turkey',
    mealPlan: 'HB',
    includesGuide: true,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'Heritage', color: '#1F6F78' }],
    includes: ['4★ Hotels', 'Intercity AC coach', 'Guided shrine visits', 'Half board meals', 'Professional tour leader'],
    highlights: ['Eyüp Sultan & Blue Mosque', 'Mevlana Rumi Complex (Konya)', 'Green Mosque & Tomb (Bursa)', 'Bosphorus Cruise'],
    itinerary: [
      { day: 1, title: 'Arrive Istanbul', description: 'Hotel check-in and Bosphorus sunset walk.' },
      { day: 3, title: 'Old Istanbul Ziyarat', description: 'Eyüp Sultan Mosque, Hagia Sophia & Topkapi Palace.' },
      { day: 5, title: 'Konya Mevlana Visit', description: 'Mevlana Rumi shrine and whirling dervish center.' },
      { day: 8, title: 'Departure', description: 'Transfer to Istanbul airport.' },
    ],
    hotels: [
      { city: 'Istanbul', name: 'Bosphorus Palace Hotel', stars: 4 },
      { city: 'Konya', name: 'Grand Konya Hotel', stars: 4 },
    ],
    transport: 'Private VIP Mercedes Sprinter',
  },
  {
    id: 'demo-turkey-cappadocia',
    name: 'Turkey & Cappadocia Discovery 7 Days',
    title: 'Turkey & Cappadocia Discovery 7 Days',
    packageName: 'Turkey & Cappadocia Discovery 7 Days',
    slug: 'turkey-cappadocia-7-days',
    description: 'Hot air balloon experience, Goreme open air museum, Grand Bazaar & Bosphorus cruise.',
    image:
      'https://images.unsplash.com/photo-1641128324972-af3212f0f6bd?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1641128324972-af3212f0f6bd?auto=format&fit=crop&w=900&q=70',
    price: 1650,
    basePrice: 1650,
    currency: 'USD',
    duration: 7,
    nights: 6,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.8,
    category: 'International',
    packageCategory: 'International',
    packageSubType: 'Holiday',
    tripScope: 'International',
    destinationLabel: 'Istanbul & Cappadocia, Turkey',
    mealPlan: 'BB',
    includesGuide: true,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'Top Rated', color: '#D97706' }],
    includes: ['Cave hotel in Cappadocia', 'Domestic Turkish flight', 'Daily breakfast', 'Guided sightseeing'],
    highlights: ['Hot air balloon ride option', 'Underground City of Derinkuyu', 'Bosphorus Yacht Tour'],
    itinerary: [
      { day: 1, title: 'Arrival in Istanbul', description: 'Meet & greet and hotel transfer.' },
      { day: 3, title: 'Flight to Cappadocia', description: 'Check in to authentic cave hotel.' },
      { day: 4, title: 'Hot Air Balloon & Valleys', description: 'Sunrise balloon tour over fairy chimneys.' },
      { day: 7, title: 'Departure', description: 'Flight to Istanbul and connection home.' },
    ],
    hotels: [
      { city: 'Istanbul', name: 'Golden Horn Boutique', stars: 4 },
      { city: 'Cappadocia', name: 'Sultan Cave Suites', stars: 4 },
    ],
    transport: 'Domestic flights + private airport transfers',
  },

  // 2. UAE (UNITED ARAB EMIRATES)
  {
    id: 'demo-dubai-family',
    name: 'Dubai Family Holiday 6 Days',
    title: 'Dubai Family Holiday',
    packageName: 'Dubai Family Holiday 6 Days',
    slug: 'dubai-family-holiday-6-days',
    description: '4★ hotel near Dubai Marina, desert safari with BBQ dinner, city tour & Dhow cruise.',
    image:
      'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=900&q=70',
    price: 1299,
    basePrice: 1299,
    currency: 'USD',
    duration: 6,
    nights: 5,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.7,
    category: 'International',
    packageCategory: 'International',
    packageSubType: 'Holiday',
    tripScope: 'International',
    destinationLabel: 'Dubai, UAE',
    mealPlan: 'BB',
    includesGuide: false,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'Family Favorite', color: '#C47B2B' }],
    includes: ['5 nights 4★ hotel stay', 'Roundtrip airport transfers', 'Desert safari with 4x4 dune bashing', 'Marina Dhow cruise dinner', 'Burj Khalifa ticket'],
    highlights: ['Burj Khalifa 124th floor view', 'Desert safari & camel riding', 'Dubai Mall & Fountain show'],
    itinerary: [
      { day: 1, title: 'Arrive Dubai', description: 'Private transfer from DXB to Marina hotel.' },
      { day: 2, title: 'Dubai City Tour & Burj Khalifa', description: 'Old Dubai gold souk & modern landmarks.' },
      { day: 3, title: 'Desert Safari', description: 'Afternoon dune bashing, BBQ dinner & live show.' },
      { day: 5, title: 'Marina Dhow Cruise', description: 'Evening dinner cruise on luxury traditional boat.' },
      { day: 6, title: 'Departure', description: 'Transfer to airport.' },
    ],
    hotels: [{ city: 'Dubai', name: 'Millennium Place Marina', stars: 4 }],
    transport: 'Private VIP vehicle transfers',
  },

  // 3. MALAYSIA
  {
    id: 'demo-malaysia-highlights',
    name: 'Malaysia Wonder & Kuala Lumpur 6 Days',
    title: 'Malaysia Wonder 6 Days',
    packageName: 'Malaysia Wonder & Kuala Lumpur 6 Days',
    slug: 'malaysia-wonder-6-days',
    description: 'Petronas Twin Towers, Batu Caves, Genting Highlands cable car & shopping in KL.',
    image:
      'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?auto=format&fit=crop&w=900&q=70',
    price: 1150,
    basePrice: 1150,
    currency: 'USD',
    duration: 6,
    nights: 5,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.6,
    category: 'International',
    packageCategory: 'International',
    packageSubType: 'Holiday',
    tripScope: 'International',
    destinationLabel: 'Kuala Lumpur & Genting, Malaysia',
    mealPlan: 'BB',
    includesGuide: true,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'Value Deal', color: '#1F6F78' }],
    includes: ['5 nights 4★ hotel in Bukit Bintang', 'Genting cable car tickets', 'Batu Caves tour', 'Airport transfers'],
    highlights: ['Petronas Twin Towers skybridge', 'Batu Caves Murugan temple', 'Genting SkyWorlds theme park'],
    itinerary: [
      { day: 1, title: 'Arrive Kuala Lumpur', description: 'Airport pickup to Bukit Bintang hotel.' },
      { day: 2, title: 'KL City Tour', description: 'Twin Towers, King Palace & National Mosque.' },
      { day: 3, title: 'Batu Caves & Genting', description: 'Cable car ride and mountain resort.' },
      { day: 6, title: 'Departure', description: 'Transfer to KLIA airport.' },
    ],
    hotels: [{ city: 'Kuala Lumpur', name: 'Dorsett Kuala Lumpur', stars: 4 }],
    transport: 'Private AC tourist car',
  },

  // 4. AZERBAIJAN
  {
    id: 'demo-baku-azerbaijan',
    name: 'Baku City & Fire Mountain 5 Days',
    title: 'Baku City Tour',
    packageName: 'Baku City & Fire Mountain 5 Days',
    slug: 'baku-azerbaijan-5-days',
    description: 'Explore Flame Towers, Maiden Tower, Old City (Icherisheher), Yanar Dag & Gobustan.',
    image:
      'https://images.unsplash.com/photo-1618773928121-c32242e63f39?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1618773928121-c32242e63f39?auto=format&fit=crop&w=900&q=70',
    price: 899,
    basePrice: 899,
    currency: 'USD',
    duration: 5,
    nights: 4,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.8,
    category: 'International',
    packageCategory: 'International',
    packageSubType: 'Holiday',
    tripScope: 'International',
    destinationLabel: 'Baku, Azerbaijan',
    mealPlan: 'BB',
    includesGuide: true,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'Trending', color: '#E11D48' }],
    includes: ['4 nights 4★ hotel', 'Baku Old Town walking tour', 'Ateshgah Fire Temple excursion', 'Airport transfers'],
    highlights: ['Flame Towers illumination', 'Yanar Dag eternal burning hill', 'Heydar Aliyev Cultural Center'],
    itinerary: [
      { day: 1, title: 'Arrive Baku', description: 'Transfer to hotel and evening boulevard walk.' },
      { day: 2, title: 'Old City & Flame Towers', description: 'UNESCO Shirvanshahs Palace and Maiden Tower.' },
      { day: 3, title: 'Gobustan & Mud Volcanoes', description: 'Rock art petroglyphs and active mud volcanoes.' },
      { day: 5, title: 'Departure', description: 'Transfer to Heydar Aliyev Airport.' },
    ],
    hotels: [{ city: 'Baku', name: 'Winter Park Hotel Baku', stars: 4 }],
    transport: 'Private vehicle throughout',
  },

  // 5. THAILAND
  {
    id: 'demo-thailand-islands',
    name: 'Bangkok & Phuket Island Explorer 7 Days',
    title: 'Thailand Explorer 7 Days',
    packageName: 'Bangkok & Phuket Island Explorer 7 Days',
    slug: 'thailand-islands-7-days',
    description: 'Grand Palace, floating markets, Phuket beaches & James Bond Island speedboat tour.',
    image:
      'https://images.unsplash.com/photo-1506665531195-3566af2b4dfa?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1506665531195-3566af2b4dfa?auto=format&fit=crop&w=900&q=70',
    price: 1050,
    basePrice: 1050,
    currency: 'USD',
    duration: 7,
    nights: 6,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.7,
    category: 'International',
    packageCategory: 'International',
    packageSubType: 'Holiday',
    tripScope: 'International',
    destinationLabel: 'Bangkok & Phuket, Thailand',
    mealPlan: 'BB',
    includesGuide: true,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'Island Tour', color: '#0284C7' }],
    includes: ['Hotels in Bangkok & Phuket', 'Domestic flight included', 'Speedboat island tour with lunch', 'Transfers'],
    highlights: ['Phi Phi Islands & Maya Bay', 'Bangkok Grand Palace', 'Patong Beach & night markets'],
    itinerary: [
      { day: 1, title: 'Arrive Bangkok', description: 'Transfer to Sukhumvit hotel.' },
      { day: 2, title: 'Bangkok Temples', description: 'Wat Arun, Grand Palace & river ferry.' },
      { day: 3, title: 'Fly to Phuket', description: 'Check in to beachfront resort.' },
      { day: 5, title: 'Phi Phi Speedboat Excursion', description: 'Snorkeling and island hopping.' },
      { day: 7, title: 'Departure', description: 'Transfer to Phuket airport.' },
    ],
    hotels: [
      { city: 'Bangkok', name: 'Centara Grand Bangkok', stars: 4 },
      { city: 'Phuket', name: 'Andaman Beach Resort', stars: 4 },
    ],
    transport: 'Private vans + speedboats',
  },

  // 6. UNITED KINGDOM (UK)
  {
    id: 'demo-uk-scotland',
    name: 'London & Edinburgh Highlights 8 Days',
    title: 'UK & Scotland Tour',
    packageName: 'London & Edinburgh Highlights 8 Days',
    slug: 'london-edinburgh-8-days',
    description: 'Tower Bridge, Big Ben, high-speed train to Edinburgh Castle & Scottish Highlands excursion.',
    image:
      'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=900&q=70',
    price: 2250,
    basePrice: 2250,
    currency: 'USD',
    duration: 8,
    nights: 7,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.9,
    category: 'International',
    packageCategory: 'International',
    packageSubType: 'Holiday',
    tripScope: 'International',
    destinationLabel: 'London & Edinburgh, United Kingdom',
    mealPlan: 'BB',
    includesGuide: true,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'Europe Special', color: '#4F46E5' }],
    includes: ['Central London 4★ hotel', 'Edinburgh 4★ hotel', 'LNER First Class train London ↔ Edinburgh', 'Guided tour'],
    highlights: ['Buckingham Palace & Thames Cruise', 'Edinburgh Royal Mile & Castle', 'Loch Ness day tour'],
    itinerary: [
      { day: 1, title: 'Arrive London Heathrow', description: 'Meet driver and transfer to hotel.' },
      { day: 2, title: 'London Icons', description: 'Westminster Abbey, Big Ben & London Eye.' },
      { day: 4, title: 'Train to Edinburgh', description: 'Scenic high-speed train through English countryside.' },
      { day: 6, title: 'Scottish Highlands', description: 'Glencoe, Loch Ness & picturesque villages.' },
      { day: 8, title: 'Departure', description: 'Transfer to Edinburgh airport.' },
    ],
    hotels: [
      { city: 'London', name: 'Park Plaza Westminster Bridge', stars: 4 },
      { city: 'Edinburgh', name: 'Apex Grassmarket Hotel', stars: 4 },
    ],
    transport: 'Train + private chauffeured transfers',
  },

  // ============================================================
  // PAKISTAN-RELATED PACKAGES — ALL PRICES STRICTLY IN PKR
  // ============================================================
  {
    id: 'demo-hunza',
    name: 'Hunza & Skardu Expedition 7 Days',
    title: 'Hunza & Skardu',
    packageName: 'Hunza & Skardu Expedition 7 Days',
    slug: 'hunza-skardu-7-days',
    description: 'Northern Pakistan paradise — Attabad Lake, Baltit Fort, Shangrila Resort, hotels & 4x4 Prado.',
    image:
      'https://images.unsplash.com/photo-1589802829985-817e51171b92?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1589802829985-817e51171b92?auto=format&fit=crop&w=900&q=70',
    price: 175000,
    basePrice: 175000,
    currency: 'PKR',
    duration: 7,
    nights: 6,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.9,
    category: 'Pakistan',
    packageCategory: 'Domestic',
    packageSubType: 'Adventure',
    tripScope: 'Domestic',
    destinationLabel: 'Hunza & Skardu, Pakistan',
    mealPlan: 'HB',
    includesGuide: true,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'PKR Price', color: '#16A34A' }, { label: 'Domestic', color: '#2E7D4F' }],
    includes: ['Deluxe hotel stays', 'Dedicated 4x4 Prado with driver', 'Breakfast & dinner included', 'Fuel & toll taxes', 'Attabad Lake boating'],
    highlights: ['Attabad Lake crystal waters', 'Baltit & Altit Forts', 'Shangrila Resort & Lower Kachura', 'Passu Cones view'],
    itinerary: [
      { day: 1, title: 'Islamabad to Chilas', description: 'Scenic drive via Babusar Pass / Karakoram Highway.' },
      { day: 2, title: 'Chilas to Hunza Karimabad', description: 'Rakaposhi viewpoint and arrival in Hunza.' },
      { day: 3, title: 'Attabad Lake & Passu', description: 'Boating, Passu suspension bridge and Hussaini bridge.' },
      { day: 5, title: 'Hunza to Skardu', description: 'Drive along the Indus river to Skardu valley.' },
      { day: 7, title: 'Return to Islamabad', description: 'Flight from Skardu or drive back with tour leader.' },
    ],
    hotels: [
      { city: 'Hunza', name: 'Hunza Serena Inn / Eagle Nest', stars: 4 },
      { city: 'Skardu', name: 'Shangrila Resort Skardu', stars: 4 },
    ],
    transport: 'Dedicated 4x4 Prado with professional mountain driver',
  },
  {
    id: 'demo-swat',
    name: 'Swat & Kalam Valley 5 Days',
    title: 'Swat Valley Escape',
    packageName: 'Swat & Kalam Valley 5 Days',
    slug: 'swat-kalam-5-days',
    description: 'Switzerland of Pakistan — Malam Jabba ski resort, Kalam forest, Mahodand Lake & hotel stay.',
    image:
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=900&q=70',
    price: 95000,
    basePrice: 95000,
    currency: 'PKR',
    duration: 5,
    nights: 4,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.7,
    category: 'Pakistan',
    packageCategory: 'Domestic',
    packageSubType: 'Holiday',
    tripScope: 'Domestic',
    destinationLabel: 'Swat & Kalam, Pakistan',
    mealPlan: 'BB',
    includesGuide: true,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'PKR Price', color: '#16A34A' }],
    includes: ['4 nights stay in Kalam & Mingora', 'Private AC Grand Cabin / GLI', 'Malam Jabba chairlift assistance', 'Daily breakfast'],
    highlights: ['Malam Jabba ski resort', 'Mahodand Lake jeep ride', 'Ushu Forest & Kalam bazaar'],
    itinerary: [
      { day: 1, title: 'Islamabad to Swat', description: 'Swat expressway drive, arrive in Mingora / Fizagat.' },
      { day: 2, title: 'Malam Jabba Excursion', description: 'Chairlift and zip line adventure.' },
      { day: 3, title: 'Mingora to Kalam', description: 'Drive through picturesque valleys and riverside.' },
      { day: 4, title: 'Mahodand Lake', description: '4x4 jeep trek to Mahodand and Saifullah Lakes.' },
      { day: 5, title: 'Return to Islamabad', description: 'Souvenir shopping and return drive.' },
    ],
    hotels: [
      { city: 'Mingora', name: 'Serena Hotel Swat', stars: 4 },
      { city: 'Kalam', name: 'Walnut Heights Kalam', stars: 3 },
    ],
    transport: 'Private Toyota Corolla / Grand Cabin from Islamabad',
  },
  {
    id: 'demo-naran',
    name: 'Naran, Kaghan & Shogran 5 Days',
    title: 'Naran & Shogran Tour',
    packageName: 'Naran, Kaghan & Shogran 5 Days',
    slug: 'naran-kaghan-shogran-5-days',
    description: 'Lake Saif-ul-Malook, Siri Paye meadows, Kunhar river rafting & family hotel stay.',
    image:
      'https://images.unsplash.com/photo-1596401057633-54a8fe8ef647?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1596401057633-54a8fe8ef647?auto=format&fit=crop&w=900&q=70',
    price: 85000,
    basePrice: 85000,
    currency: 'PKR',
    duration: 5,
    nights: 4,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.8,
    category: 'Pakistan',
    packageCategory: 'Domestic',
    packageSubType: 'Holiday',
    tripScope: 'Domestic',
    destinationLabel: 'Naran & Kaghan, Pakistan',
    mealPlan: 'BB',
    includesGuide: true,
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'PKR Price', color: '#16A34A' }],
    includes: ['4 nights riverside hotel', 'Jeep ride to Lake Saif-ul-Malook', '4x4 to Siri Paye meadows', 'Daily breakfast'],
    highlights: ['Legendary Saif-ul-Malook fairy lake', 'Siri Paye lush plateau', 'Kunhar River trout fish'],
    itinerary: [
      { day: 1, title: 'Islamabad to Shogran', description: 'Hazara motorway, Balakot and Kiwi Shogran.' },
      { day: 2, title: 'Siri Paye to Naran', description: 'Morning jeep safari and afternoon transfer to Naran.' },
      { day: 3, title: 'Lake Saif-ul-Malook', description: 'Jeep excursion to famous alpine lake.' },
      { day: 4, title: 'Babusar Top & Lulusar Lake', description: 'High altitude mountain pass excursion.' },
      { day: 5, title: 'Return to Islamabad', description: 'Safe return drop-off in Islamabad/Rawalpindi.' },
    ],
    hotels: [
      { city: 'Shogran', name: 'Pine Park Hotel Shogran', stars: 3 },
      { city: 'Naran', name: 'Demanchi Hotel Naran', stars: 4 },
    ],
    transport: 'Private AC car + 4x4 Mountain Willys Jeep',
  },
  {
    id: 'demo-murree',
    name: 'Murree & Bhurban Weekend 3 Days',
    title: 'Murree Weekend Getaway',
    packageName: 'Murree & Bhurban Weekend 3 Days',
    slug: 'murree-bhurban-weekend-3-days',
    description: 'Quick mountain retreat — Mall Road, Patriata chairlift, Bhurban resort & Islamabad pickup.',
    image:
      'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=900&q=70',
    price: 45000,
    basePrice: 45000,
    currency: 'PKR',
    duration: 3,
    nights: 2,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.4,
    category: 'Pakistan',
    packageCategory: 'Local',
    packageSubType: 'Weekend',
    tripScope: 'Local',
    destinationLabel: 'Murree & Bhurban, Pakistan',
    mealPlan: 'BB',
    includesTransport: true,
    includesHotel: true,
    isFeatured: true,
    badges: [{ label: 'PKR Price', color: '#16A34A' }, { label: 'Weekend Deal', color: '#2E7D4F' }],
    includes: ['2 nights luxury hotel in Bhurban', 'Roundtrip car from Islamabad / Rawalpindi', 'Daily buffet breakfast'],
    highlights: ['Patriata New Murree cable car', 'Mall Road evening stroll', 'Pine forest serenity'],
    itinerary: [
      { day: 1, title: 'Islamabad to Murree', description: 'Pickup and drive via Murree expressway to Bhurban.' },
      { day: 2, title: 'Patriata & Mall Road', description: 'Cable car ride and evening shopping.' },
      { day: 3, title: 'Return', description: 'Checkout and drop-off in Islamabad.' },
    ],
    hotels: [{ city: 'Bhurban', name: 'Pearl Continental Bhurban', stars: 5 }],
    transport: 'Private sedan car from Islamabad',
  },
  {
    id: 'demo-lahore',
    name: 'Lahore Heritage & Food Culture Tour',
    title: 'Lahore Heritage Tour',
    packageName: 'Lahore Heritage & Food Culture Tour',
    slug: 'lahore-heritage-tour',
    description: 'Badshahi Mosque, Lahore Fort, Walled City food street, Wagah Border flag ceremony & AC coach.',
    image:
      'https://images.unsplash.com/photo-1566438480900-0609be27a4be?auto=format&fit=crop&w=900&q=70',
    packageImage:
      'https://images.unsplash.com/photo-1566438480900-0609be27a4be?auto=format&fit=crop&w=900&q=70',
    price: 18500,
    basePrice: 18500,
    currency: 'PKR',
    duration: 1,
    nights: 0,
    nightsInMakkah: 0,
    nightsInMadina: 0,
    rating: 4.8,
    category: 'Pakistan',
    packageCategory: 'Local',
    packageSubType: 'DayTour',
    tripScope: 'Local',
    destinationLabel: 'Lahore, Pakistan',
    mealPlan: 'Traditional Dinner Included',
    includesGuide: true,
    includesTransport: true,
    includesHotel: false,
    isFeatured: true,
    badges: [{ label: 'PKR Price', color: '#16A34A' }, { label: '1 Day Tour', color: '#1F6F78' }],
    includes: ['Certified historical guide', 'AC vehicle throughout the day', 'Entry tickets to monuments', 'Traditional Haveli dinner'],
    highlights: ['Mughal Badshahi Mosque & Shahi Qila', 'Wagah Border patriotic flag ceremony', 'Food Street gourmet experience'],
    itinerary: [
      { day: 1, title: 'Full Day Lahore Journey', description: '9:00 AM pickup → Badshahi Mosque → Delhi Gate → Wagah Border → Dinner at Fort Road Food Street.' },
    ],
    hotels: [],
    transport: 'Private AC Toyota Hiace / GLI',
  },
];

export const DEMO_DESTINATION_SUGGESTIONS = [
  { id: 1, label: 'Makkah & Madina', subtitle: 'Saudi Arabia · Umrah' },
  { id: 2, label: 'Istanbul & Cappadocia', subtitle: 'Turkey · International' },
  { id: 3, label: 'Dubai & Abu Dhabi', subtitle: 'UAE · Holiday' },
  { id: 4, label: 'Kuala Lumpur & Genting', subtitle: 'Malaysia · International' },
  { id: 5, label: 'Baku & Fire Mountain', subtitle: 'Azerbaijan · Holiday' },
  { id: 6, label: 'Bangkok & Phuket', subtitle: 'Thailand · Tropical Holiday' },
  { id: 7, label: 'London & Edinburgh', subtitle: 'United Kingdom · Europe' },
  { id: 8, label: 'Hunza & Skardu', subtitle: 'Pakistan · Domestic (PKR)' },
  { id: 9, label: 'Swat & Kalam', subtitle: 'Pakistan · Domestic (PKR)' },
  { id: 10, label: 'Naran & Kaghan', subtitle: 'Pakistan · Domestic (PKR)' },
  { id: 11, label: 'Murree & Bhurban', subtitle: 'Pakistan · Weekend (PKR)' },
  { id: 12, label: 'Lahore Heritage', subtitle: 'Pakistan · Day Tour (PKR)' },
];

export function getDemoPackageById(id) {
  if (!id) return null;
  const key = String(id).toLowerCase();
  return (
    DEMO_PACKAGES.find(
      (p) =>
        String(p.id).toLowerCase() === key ||
        String(p.slug || '').toLowerCase() === key
    ) || null
  );
}

export default DEMO_PACKAGES;
